export default [
  {
    path: '/v2/admin/inventory-lists',
    name: 'inventory-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/inventory-list/index-v2.vue')
  },
  {
    path: '/v2/admin/summary-inventory-lists',
    name: 'inventory-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/inventory-list/summary.vue')
  }
]
